import { Box, Button, ButtonGroup } from '@chakra-ui/react';
import { Modal } from 'shared-components';
import { useTranslation } from "react-i18next";

interface ReinstateOfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export function ReinstateOfferModal({ isOpen, onClose, onConfirm, isLoading }: Readonly<ReinstateOfferModalProps>) {
    const { t } = useTranslation('navigation');
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title={t('navigation:reinstateOffer')}
      footer={
        <ButtonGroup spacing={3} size={'lg'}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="solid" isDisabled={false} onClick={onConfirm} isLoading={isLoading}>
            Reinstate offer
          </Button>
        </ButtonGroup>
      }
    >
      <Box>
        {t('navigation:theOfferWillBeReinstatedToApplie')}
                    </Box>
    </Modal>
  );
}
